<template>
  <SfMessageOuterContainer data-testid="talking-point-suggestion">
    <SfMessageContainer :read="true">
      <template #heading>
        <span class="tw-text-sf-ai-dark tw-font-medium tw-text-sm">
          {{ assistantCheckIndicatorText }}
        </span>
      </template>
      <template #body>
        <div
          v-dompurify-html="text"
          class="tw-text-sm talking-point-suggestion__description"
        />
      </template>
      <template #footer>
        <div class="tw-pt-2">
          <SfButtonInverted
            small
            inline
            data-heap="add-to-agenda"
            @click="addToAgenda"
          >
            <span
              class="
                tw-flex tw-flex-row tw-items-center tw-align-baseline tw-gap-2
              "
            >
              <i class="fa fa-arrow-left" />
              {{ addToAgendaLabel }}
            </span>
          </SfButtonInverted>
        </div>
      </template>
    </SfMessageContainer>
  </SfMessageOuterContainer>
</template>

<script setup lang="ts">
import { SfButtonInverted } from '@app/shared/vue/components/sf-button'
import SfMessageContainer from '@app/shared/vue/components/sf-message/sf-message-container.vue'
import SfMessageOuterContainer from '@app/shared/vue/components/sf-message/sf-message-outer-container.vue'

import useI18n from '@app/shared/vue/composables/use-I18n'

interface Props {
  text: string
}

const I18n = useI18n()

const props = withDefaults(defineProps<Props>(), {
  text: '',
})

const assistantCheckIndicatorText = I18n.t(
  'account_entry.assistant.check.indicator'
)

const addToAgendaLabel = I18n.t(
  'client_meetings.meeting_preparation.suggestion.add_to_agenda'
)

function addToAgenda() {
  window.eventHub.$emit('add-suggested-talking-point', props.text)
}
</script>

<style lang="scss">
.talking-point-suggestion {
  &__description {
    blockquote {
      margin-bottom: 16px;
    }

    ul,
    ol {
      padding-left: 16px;
      margin-bottom: 16px;
    }

    ul {
      list-style-type: disc;
    }

    ol {
      list-style-type: decimal;
    }
  }
}
</style>
